import { render, staticRenderFns } from "./metasDinero.vue?vue&type=template&id=3d5d4c33&scoped=true"
import script from "./metasDinero.vue?vue&type=script&lang=js"
export * from "./metasDinero.vue?vue&type=script&lang=js"
import style0 from "./metasDinero.vue?vue&type=style&index=0&id=3d5d4c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d4c33",
  null
  
)

export default component.exports